type Props = {
  text: string;
  color?: "hibisco" | "cactus" | "ink" | "mezcal";
  size?: number;
  rotate?: number;
  className?: string;
};

const COLORS: Record<NonNullable<Props["color"]>, string> = {
  hibisco: "#B83C50",
  cactus:  "#2D5040",
  ink:     "#1A1612",
  mezcal:  "#C84B1A",
};

// Circular stamp with text on path.
export function Stamp({ text, color = "hibisco", size = 110, rotate = -8, className = "" }: Props) {
  const c = COLORS[color];
  const r = size / 2 - 4;
  const inner = size / 2 - 14;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={`stamp-text ${className}`}
      style={{ transform: `rotate(${rotate}deg)`, mixBlendMode: "multiply" }}
    >
      <defs>
        <path id={`p-${text}`} d={`M ${size/2}, ${size/2} m -${inner-4}, 0 a ${inner-4},${inner-4} 0 1,1 ${(inner-4)*2},0 a ${inner-4},${inner-4} 0 1,1 -${(inner-4)*2},0`} />
      </defs>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={c} strokeWidth="3" />
      <circle cx={size/2} cy={size/2} r={r - 6} fill="none" stroke={c} strokeWidth="1" />
      <text fill={c} fontSize="10" fontFamily="JetBrains Mono, monospace">
        <textPath href={`#p-${text}`} startOffset="0%">{text} · {text} · </textPath>
      </text>
      <circle cx={size/2} cy={size/2} r={inner - 14} fill={c} opacity="0.08" />
    </svg>
  );
}

// Rectangular "stamped" badge — used to overlay PAID, SOLD OUT, etc.
export function PaidStamp({ children, color = "hibisco", className = "" }: { children: React.ReactNode; color?: Props["color"]; className?: string }) {
  return (
    <span
      className={`stamped-overlay font-mono text-sm font-bold ${className}`}
      style={{ color: COLORS[color || "hibisco"] }}
    >
      {children}
    </span>
  );
}
